export const ONBOARDING_FLOW_BUILDER_TRY_TO_START = 'ONBOARDING_FLOW_BUILDER_TRY_TO_START'
export const ONBOARDING_FLOW_BUILDER_END = 'ONBOARDING_FLOW_BUILDER_END'

export const ATTACHMENT_UPLOAD = 'ATTACHMENT_UPLOAD'
export const ATTACHMENT_UPLOAD_REQUEST = 'ATTACHMENT_UPLOAD_REQUEST'
export const ATTACHMENT_UPLOAD_RESPONSE = 'ATTACHMENT_UPLOAD_RESPONSE'
export const ATTACHMENT_UPLOAD_ERROR = 'ATTACHMENT_UPLOAD_ERROR'
